import { Injectable } from '@angular/core';
import { FlxLoggerService } from '@fluxys/core';
import { TranslocoConfig, TranslocoMissingHandler } from '@jsverse/transloco';

@Injectable()
export class MissingTranslationHandlerService implements TranslocoMissingHandler {
  constructor(private readonly logger: FlxLoggerService) {}
  handle(key: string, config: TranslocoConfig): string {
    if (!config.prodMode) {
      const msg = `Missing translation for '${key}', put a breakpoint here`;
      this.logger.warn(`%c ${msg}`, 'font-size: 12px; color: red');
    }

    return key;
  }
}
